export enum EnumCouponError{
    Unpublished = 'unpublished',
    Outdated = 'outdated',
    BadUserId = 'bad-user-id',
    BadUserType = 'bad-user-type',
    AlreadyUsedByUserId = 'already-used-by-user-id',
    AlreadyUsedByPhoneOrEmail = 'already-used-by-phone-or-email',
    NotFound = 'not-found',
    AlreadyApplied = 'already-applied', // when apply promoCode to basket
    ZeroDiscount = 'zero-discount',
    EmptyCode = 'empty-code',
    IncompatibleWithPersonalDiscountCoupon = 'incompatible-with-personal-discount-coupon',



}